import e from "@dialpad/dialtone-tokens/layered/themes/tokens-melon-colors.css?inline";
//#region themes/melon.js
var t = { brand: {
	css: e,
	name: "melon"
} };
//#endregion
export { t as default };
